import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var HousingPriorityCertification =
/*#__PURE__*/
function (_BaseData) {
  _inherits(HousingPriorityCertification, _BaseData);

  function HousingPriorityCertification() {
    _classCallCheck(this, HousingPriorityCertification);

    return _possibleConstructorReturn(this, _getPrototypeOf(HousingPriorityCertification).call(this, "HousingPriorityCertification"));
  }

  _createClass(HousingPriorityCertification, [{
    key: "GetByUserId",
    value: function () {
      var _GetByUserId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(userId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByUserId"), {
                  params: {
                    userId: userId
                  }
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByUserId(_x) {
        return _GetByUserId.apply(this, arguments);
      }

      return GetByUserId;
    }()
  }, {
    key: "GetByStatusId",
    value: function () {
      var _GetByStatusId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(statusId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByStatusId"), {
                  params: {
                    statusId: statusId
                  }
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function GetByStatusId(_x2) {
        return _GetByStatusId.apply(this, arguments);
      }

      return GetByStatusId;
    }()
  }, {
    key: "GetByStatusIdAndYear",
    value: function () {
      var _GetByStatusIdAndYear = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(statusId, year) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByStatusIdAndYear"), {
                  params: {
                    year: year,
                    statusId: statusId
                  }
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetByStatusIdAndYear(_x3, _x4) {
        return _GetByStatusIdAndYear.apply(this, arguments);
      }

      return GetByStatusIdAndYear;
    }()
  }, {
    key: "GetByProjectId",
    value: function () {
      var _GetByProjectId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(projectId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByProjectId"), {
                  params: {
                    projectId: projectId
                  }
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetByProjectId(_x5) {
        return _GetByProjectId.apply(this, arguments);
      }

      return GetByProjectId;
    }()
  }, {
    key: "GetHousingPriorityCertification",
    value: function () {
      var _GetHousingPriorityCertification = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(housingPriorityCertificationId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetHousingPriorityCertification"), {
                  params: {
                    housingPriorityCertificationId: housingPriorityCertificationId
                  }
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetHousingPriorityCertification(_x6) {
        return _GetHousingPriorityCertification.apply(this, arguments);
      }

      return GetHousingPriorityCertification;
    }()
  }, {
    key: "UpdateLRAContact",
    value: function () {
      var _UpdateLRAContact = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(contact, projectId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.post("/api/".concat(this._controller, "/UpdateLRAContact/").concat(projectId), contact));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function UpdateLRAContact(_x7, _x8) {
        return _UpdateLRAContact.apply(this, arguments);
      }

      return UpdateLRAContact;
    }()
  }]);

  return HousingPriorityCertification;
}(BaseData);

export default new HousingPriorityCertification();